(function () {
  const el = document.getElementById('SimuladorVentas');
  if (!el) return;

  const STORAGE_KEY = 'simulador-ventas-cerrado';
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
  } catch (e) {}

  const lista = (attr) =>
    (el.dataset[attr] || '')
      .split(';')
      .map((item) => item.trim())
      .filter(Boolean);

  const nombres = lista('nombres');
  const ciudades = lista('ciudades');
  const tiempos = lista('tiempos');
  if (!nombres.length || !tiempos.length) return;

  const ms = (value, fallback, min) => {
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n >= min ? n : fallback;
  };
  const INICIO = ms(el.dataset.inicio, 6000, 0);
  const INTERVALO = ms(el.dataset.intervalo, 48000, 5000);
  const VISIBLE = Math.min(ms(el.dataset.visible, 8000, 2000), INTERVALO - 1000);

  const who = el.querySelector('.sim-venta__who');
  const when = el.querySelector('.sim-venta__when');

  // Evita repetir el mismo valor dos veces seguidas
  const ultimo = {};
  const elegir = (arr, key) => {
    if (arr.length === 1) return arr[0];
    let i;
    do {
      i = Math.floor(Math.random() * arr.length);
    } while (i === ultimo[key]);
    ultimo[key] = i;
    return arr[i];
  };

  // No tapar el botón fijo de compra cuando la notificación va abajo
  const ajustarPosicion = () => {
    let offset = 0;
    const sticky = document.querySelector('.sticky-atc');
    if (sticky) {
      const rect = sticky.getBoundingClientRect();
      const visible = rect.height > 0 && rect.top < window.innerHeight && getComputedStyle(sticky).visibility !== 'hidden';
      if (visible && rect.bottom >= window.innerHeight - 4) offset = window.innerHeight - rect.top;
    }
    el.style.setProperty('--sim-offset', offset + 'px');
  };

  // No mostrar mientras el cliente está en el carrito o llenando un formulario
  const ocupado = () =>
    document.body.classList.contains('overflow-hidden') ||
    document.querySelector('cart-drawer.active, .pedido-wa[open]') !== null;

  let hideTimer;
  let loopTimer;

  const mostrar = () => {
    if (document.hidden || ocupado()) return;
    const ciudad = ciudades.length ? ' de ' + elegir(ciudades, 'ciudad') : '';
    who.textContent = elegir(nombres, 'nombre') + ciudad + ' compró:';
    when.textContent = elegir(tiempos, 'tiempo');
    ajustarPosicion();
    el.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => el.classList.remove('is-visible'), VISIBLE);
  };

  const iniciar = (delay) => {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(function tick() {
      mostrar();
      loopTimer = setTimeout(tick, INTERVALO);
    }, delay);
  };

  // Pausar con la pestaña en segundo plano para no acumular notificaciones
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(loopTimer);
      el.classList.remove('is-visible');
    } else {
      iniciar(INICIO);
    }
  });

  el.querySelector('.sim-venta__close').addEventListener('click', () => {
    clearTimeout(loopTimer);
    clearTimeout(hideTimer);
    el.classList.remove('is-visible');
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  });

  iniciar(INICIO);
})();
